'use client';

import { c as _c } from "react/compiler-runtime";
import { useParams } from 'next/navigation';
import invariant from 'tiny-invariant';
import { CacheKey } from '@libs/vercel';
import { IS_TEST } from '../constants/env';
export function useCacheKey() {
  const $ = _c(6);
  const params = useParams();
  if (IS_TEST) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = {
        key: "mock",
        headers: new Map(),
        cookies: new Map(),
        search: new Map()
      };
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  invariant(params?.cacheKey, "CacheKey is required");
  let t0;
  if ($[1] !== params.cacheKey) {
    t0 = CacheKey.decode(params.cacheKey);
    $[1] = params.cacheKey;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== params.cacheKey || $[4] !== t0) {
    t1 = {
      ...t0,
      key: params.cacheKey
    };
    $[3] = params.cacheKey;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}